module.exports = __webpack_public_path__ + "static/media/success.83435c9a.png";